function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export { _defineProperty as _ };
//# sourceMappingURL=dep-66374d0e.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-icons-vue/esm/_chunks/dep-66374d0e.js
// module id = null
// module chunks = 